/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressKitProfileDetail,
    PressKitProfileDetailFromJSON,
    PressKitProfileDetailFromJSONTyped,
    PressKitProfileDetailToJSON,
} from './PressKitProfileDetail';

/**
 * 
 * @export
 * @interface GetPressKitProfileDetailResponse
 */
export interface GetPressKitProfileDetailResponse {
    /**
     * status code (HTTPと同じ)
     * @type {number}
     * @memberof GetPressKitProfileDetailResponse
     */
    status: number;
    /**
     * ステータスメッセージ。原則英語。
     * @type {string}
     * @memberof GetPressKitProfileDetailResponse
     */
    message: string;
    /**
     * 
     * @type {PressKitProfileDetail}
     * @memberof GetPressKitProfileDetailResponse
     */
    data: PressKitProfileDetail;
}

export function GetPressKitProfileDetailResponseFromJSON(json: any): GetPressKitProfileDetailResponse {
    return GetPressKitProfileDetailResponseFromJSONTyped(json, false);
}

export function GetPressKitProfileDetailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPressKitProfileDetailResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': PressKitProfileDetailFromJSON(json['data']),
    };
}

export function GetPressKitProfileDetailResponseToJSON(value?: GetPressKitProfileDetailResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': PressKitProfileDetailToJSON(value.data),
    };
}

